module.exports = __webpack_public_path__ + "static/media/icon-event__el-reino-unido-del-brexit.115f4384.svg";